<h1 mat-dialog-title *ngIf="data.target && data.target === 'qr'">{{ 'common.cta.printLabel' | translate }}</h1>
<h1 mat-dialog-title *ngIf="data.target && data.target === 'module'">{{ 'common.cta.printModule' | translate }}</h1>

<mat-dialog-content id="dataToPrint" *ngIf="data.target && data.target === 'qr'">
  <div class="row" *ngFor="let qrCode of qrCodeData">
    <table>
      <tr>
        <td>
          <qrcode [qrdata]="qrCode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="url"></qrcode>    
        </td>
        <td>
          <div style="font-family: sans-serif; font-size: 0.7rem; margin-top: 20px;">
            <span *ngIf="companyName !== ''">{{ companyName }}<br /></span>
            {{ data.propertyName }}<br />
          {{ data.propertyAddress }}<br />
          {{ data.propertyCity }}<br />
          {{ docType }}<br />
          {{ qrCode }}<br /><br />
        </div>
        <div style="text-align-last: center;">
          <img src="https://wa.archedi.it/assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}"
            height="15">
        </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-content id="dataToPrint" *ngIf="data.target && data.target === 'module'">
  <div class="row" *ngFor="let item of modulesData">
    <div class="col-12" style="margin-bottom: 30px; page-break-after: always;">
      <div class="row" style="margin-bottom: 10px;">
        <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
          <qrcode [qrdata]="item.qrCode" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="url"></qrcode>
          <div style="margin-top: 5px; font-size: 0.7rem;">{{ item.qrCode }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="clear: both; text-align: left;">
          <!-- DATI IMMOBILE -->
          <div class="row">
            <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
              <div style="margin-bottom: 0.7rem; font-size: 0.7rem;">
                <strong>{{ 'properties.dialog.propertyData' | translate }}</strong>
              </div>
              <div style="clear: both; display: flex;" *ngIf="companyName !== ''">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.master' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ companyName }}</div>
              </div>
              <div style="clear: both; display: flex;">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.property' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ data.propertyName }}</div>
              </div>
              <div style="clear: both; display: flex;">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.city' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ data.propertyCity }}</div>
              </div>
              <div style="clear: both; display: flex;">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.address' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ data.propertyAddress }}</div>
              </div>
              <div style="clear: both; display: flex;">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.uploadDate' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ item.uploadDate | dateFormat }}</div>
              </div>
              <div style="clear: both; display: flex; margin-bottom: 20px;">
                <div style="float: left; width: 200px; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.area' | translate }}</strong>
                </div>
                <div style="float: left; width: 300px">{{ 'properties.addDocumentsPage.area.' + data.area | translate }}
                </div>
              </div>
            </div>
          </div>
          <!-- DATI MODULO DOCUMENTO -->
          <div class="row">
            <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
              <div style="margin-bottom: 0.7rem; font-size: 0.7rem;">
                <strong>{{ 'properties.dialog.documentData' | translate }}</strong>
              </div>
              <!-- </div> -->
              <div class="row">
                <div class="col-12" style="margin-bottom: 10px; clear: both; display: flex;">
                  <div style="float: left; margin-right: 8px;">
                    <strong>{{ 'properties.dialog.content' | translate }}:</strong>
                  </div>
                  <div style="float: left; font-family: sans-serif;">
                    {{ data.content }}
                  </div>
                  <br>
                </div>
              </div>
              <div class="row" style="display: flex">
                <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                  <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                    <strong>{{ 'properties.dialog.topic' | translate }}</strong>
                  </div>
                  <br>
                  <div *ngFor="let topic of item.topics" style="float: left; width: 100%; margin-bottom: 0.2rem;">
                    {{ topic }}
                  </div>
                </div>
                <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                  <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                    <strong>{{ 'properties.dialog.structure' | translate }}</strong>
                  </div>
                  <br>
                  <div *ngFor="let structure of item.structures"
                    style="float: left; width: 100%; margin-bottom: 0.2rem;">
                    {{ structure.name }}
                  </div>
                </div>
                <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                  <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                    <strong>{{ 'properties.dialog.type' | translate }}</strong>
                  </div>
                  <br>
                  <div *ngFor="let doc of item.docs" style="float: left; width: 100%; margin-bottom: 0.2rem;">
                    {{ doc.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="width: 100%; font-family: sans-serif; font-size: 0.6rem;">
              <div style="margin-top: 30px; text-align-last: center;">
                <img src="https://wa.archedi.it/assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}"
                  height="20">
                <div style="margin-top: 5px;">
                  &copy; Archedi {{ year }}, tutti i diritti riservati
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div class="row w-100 mt-5" mat-dialog-actions>
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <a mat-button (click)="onPrint()" mat-raised-button mat-default class="ml-3" color="primary">
      {{ 'common.cta.print' | translate }}
      <mat-icon fontSet="fal" fontIcon="fa-print"></mat-icon>
    </a>
  </div> <!-- /.col -->
</div> <!-- /.row -->